import getters from './getters';
import actions from './actions';
import mutations from './mutations';
var state = () => ({
  options: [],
  model: null,
  information: null,
  selectedOption: null,
  customizable: null,
  encodedCustomizable: null,
  oldCustomizable: null,
  configurator: false,
  price: null
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};